import { store } from "@/_store";
import Vue from "vue";
import VueRouter from "vue-router";
import AdminReport from "../views/blog/AdminReport.vue";
import Blog from "../views/blog/Blog.vue";
import CreateReport from "../views/blog/CreateReport.vue";
import Disclaimer from "../views/Disclaimer.vue";
import Habeas from "../views/HabeasData.vue";
import Home from "../views/Home.vue";
import Landing from "../views/Landing.vue";
import Login from "../views/users/Login.vue";
import Callback from "../views/users/Callback.vue"
import Register from "../views/users/Register.vue";
import Report from "../views/blog/Report.vue";
import ResetPassword from "../views/users/ResetPassword.vue";
import SetPassword from "../views/users/SetPassword.vue";
import { jwtDecode } from "jwt-decode";

Vue.use(VueRouter);

/**
 * User roles
 */
const routesAnalysis = [
  "markets",
  "analytics",
  "advanced",
  "optimizer",
  "data",
  "overview",
  "home",
  "hedge"
];

const staffRoutes = ["docs", "staffDocs", "prds"];
const routesHedge = ["analyticsBeta", "supervisor", "trader"];
// const routesTrader = ['trader'];
const routesTestedModules = ["multi-asset"];
const routesOptimizer = ["home", "optimizer", "overview"];
const routesAnalysisHedge = [...routesAnalysis, ...routesHedge];
const routesAdmin = [
  ...routesAnalysisHedge,
  ...routesTestedModules,
  ...staffRoutes
];
const roleRoutes = {
  1: {
    routesAllowed: routesAdmin
  },
  2: {
    routesAllowed: routesAnalysis
  },
  3: {
    routesAllowed: routesHedge
  },
  5: {
    routesAllowed: routesOptimizer
  }
};

const routes = [
  {
    path: "/login",
    name: "login",
    component: Login
  },
  {
    path: "/register",
    name: "register",
    component: Register
  },
  {
    path: "/oidc/callback/",
    name: "Callback",
    component: Callback,
  },
  {
    path: "/reset_password",
    name: "reset_password",
    component: ResetPassword
  },
  {
    path: "/set_password/:id",
    name: "set_password",
    component: SetPassword
  },
  {
    path: "/profile",
    name: "profile",
    component: () =>
      import(/* webpackChunkName: "profile" */ "../views/Profile.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/data",
    name: "data",
    component: () =>
      import(/* webpackChunkName: "data" */ "../views/DataModel"),
    meta: { requiresAuth: true },
    beforeEnter(to, from, next) {
      if (
        roleRoutes[
          store.state.user.all.items.platform_role
        ].routesAllowed.includes(to.name)
      ) {
        next();
      } else {
        next({
          name:
            roleRoutes[store.state.user.all.items.platform_role]
              .routesAllowed[0]
        });
      }
    }
  },
  {
    path: "/",
    name: "overview",
    component: () =>
      import(/* webpackChunkName: "overview" */ "../views/Overview.vue"),
    meta: { requiresAuth: true },
    beforeEnter(to, from, next) {
      if (
        roleRoutes[
          store.state.user.all.items.platform_role
        ].routesAllowed.includes(to.name)
      ) {
        next();
      } else {
        next({
          name:
            roleRoutes[store.state.user.all.items.platform_role]
              .routesAllowed[0]
        });
      }
    }
  },
  {
    path: "/analytics",
    name: "analytics",
    component: () =>
      import(/* webpackChunkName: "analytics" */ "../views/Analytics.vue"),
    meta: { requiresAuth: true },
    beforeEnter(to, from, next) {
      // Check role-based access
      if (
        roleRoutes[
          store.state.user.all.items.platform_role
        ].routesAllowed.includes(to.name)
      ) {
        next();
      } else {
        next({
          name:
            roleRoutes[store.state.user.all.items.platform_role]
              .routesAllowed[0]
        });
      }
    }
  },
  {
    path: "/advanced",
    name: "advanced",
    component: () =>
      import(/* webpackChunkName: "commodity" */ "../views/Advanced.vue"),
    meta: { requiresAuth: true },
    beforeEnter(to, from, next) {
      if (
        roleRoutes[
          store.state.user.all.items.platform_role
        ].routesAllowed.includes(to.name)
      ) {
        next();
      } else {
        next({
          name:
            roleRoutes[store.state.user.all.items.platform_role]
              .routesAllowed[0]
        });
      }
    }
  },
  {
    path: "/multi-asset",
    name: "multi-asset",
    component: () =>
      import(/* webpackChunkName: "multi-asset" */ "../views/MultiAsset.vue"),
    meta: { requiresAuth: true },
    beforeEnter(to, from, next) {
      if (
        roleRoutes[
          store.state.user.all.items.platform_role
        ].routesAllowed.includes(to.name)
      ) {
        next();
      } else {
        next({
          name:
            roleRoutes[store.state.user.all.items.platform_role]
              .routesAllowed[0]
        });
      }
    }
  },
  {
    path: "/home",
    name: "home",
    component: Home,
    meta: { requiresAuth: true },
    beforeEnter(to, from, next) {
      if (
        roleRoutes[
          store.state.user.all.items.platform_role
        ].routesAllowed.includes(to.name)
      ) {
        next();
      } else {
        next({
          name:
            roleRoutes[store.state.user.all.items.platform_role]
              .routesAllowed[0]
        });
      }
    }
  },
  {
    path: "/optimizer",
    name: "optimizer",
    component: () =>
      import(/* webpackChunkName: "optimizer" */ "../views/Optimizer.vue"),
    meta: { requiresAuth: true },
    beforeEnter(to, from, next) {
      if (
        roleRoutes[
          store.state.user.all.items.platform_role
        ].routesAllowed.includes(to.name)
      ) {
        next();
      } else {
        next({
          name:
            roleRoutes[store.state.user.all.items.platform_role]
              .routesAllowed[0]
        });
      }
    }
  },
  {
    path: "/markets",
    name: "markets",
    component: () =>
      import(/* webpackChunkName: "markets" */ "../views/Markets.vue"),
    meta: {
      requiresAuth: true
    },
    beforeEnter(to, from, next) {
      if (
        roleRoutes[
          store.state.user.all.items.platform_role
        ].routesAllowed.includes(to.name)
      ) {
        next();
      } else {
        next({
          name:
            roleRoutes[store.state.user.all.items.platform_role]
              .routesAllowed[0]
        });
      }
    }
  },
  {
    path: "/hedge",
    name: "hedge",
    component: () => import("../views/Hedge.vue"),
    meta: { requiresAuth: true },
    beforeEnter(to, from, next) {
      if (
        roleRoutes[
          store.state.user.all.items.platform_role
        ].routesAllowed.includes(to.name)
      ) {
        next();
      } else {
        next({
          name:
            roleRoutes[store.state.user.all.items.platform_role]
              .routesAllowed[0]
        });
      }
    }
  },
  {
    path: "/supervisor",
    name: "supervisor",
    component: () => import("../views/Supervisor.vue"),
    meta: { requiresAuth: true },
    beforeEnter(to, from, next) {
      if (
        roleRoutes[
          store.state.user.all.items.platform_role
        ].routesAllowed.includes(to.name)
      ) {
        next();
      } else {
        next({
          name:
            roleRoutes[store.state.user.all.items.platform_role]
              .routesAllowed[0]
        });
      }
    }
  },
  {
    path: "/trader",
    name: "trader",
    component: () => import("../views/Trader.vue"),
    meta: { requiresAuth: true },
    beforeEnter(to, from, next) {
      if (
        roleRoutes[
          store.state.user.all.items.platform_role
        ].routesAllowed.includes(to.name)
      ) {
        next();
      } else {
        next({
          name:
            roleRoutes[store.state.user.all.items.platform_role]
              .routesAllowed[0]
        });
      }
    }
  },
  {
    path: "/docs",
    name: "docs",
    component: () => import("../views/documentation/Documentation"),
    meta: { requiresAuth: true },
    beforeEnter(to, from, next) {
      if (
        roleRoutes[
          store.state.user.all.items.platform_role
        ].routesAllowed.includes(to.name)
      ) {
        next();
      } else {
        next({
          name:
            roleRoutes[store.state.user.all.items.platform_role]
              .routesAllowed[0]
        });
      }
    }
  },
  {
    path: "/staffDocs",
    name: "staffDocs",
    component: () => import("../views/documentation/StaffDocumentation"),
    meta: { requiresAuth: true },
    beforeEnter(to, from, next) {
      if (
        roleRoutes[
          store.state.user.all.items.platform_role
        ].routesAllowed.includes(to.name)
      ) {
        next();
      } else {
        next({
          name:
            roleRoutes[store.state.user.all.items.platform_role]
              .routesAllowed[0]
        });
      }
    }
  },
  {
    path: "/reports",
    name: "reports",
    component: () =>
      import(/* webpackChunkName: "reports" */ "../views/Reports.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/tutorials",
    name: "tutorials",
    component: () =>
      import(/* webpackChunkName: "tutorials" */ "../views/Tutorials.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/tools",
    name: "tools",
    component: () =>
      import(/* webpackChunkName: "tools" */ "../views/Tools.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/disclaimer",
    name: "disclaimer",
    component: Disclaimer
  },
  {
    path: "/edit-user",
    name: "edituser",
    component: () =>
      import(/* webpackChunkName: "edituser" */ "../views/EditUser.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/Habeas",
    name: "Habeas",
    component: Habeas,
    meta: { requiresAuth: true }
  },
  {
    path: "/ConfirmRessetPassword",
    name: "ConfirmRessetPassword",
    component: () =>
      import(
        /* webpackChunkName: "ConfirmRessetPassword" */ "../views/ConfirmRessetPassword.vue"
      )
  },
  {
    path: "/CreateReport/",
    name: "CreateReport",
    component: CreateReport,
    meta: { requiresAuth: true }
  },
  {
    path: "/EditReport/:id",
    name: "EditReport",
    component: CreateReport,
    meta: { requiresAuth: true }
  },
  {
    path: "/AdminReport/",
    name: "AdminReport",
    component: AdminReport,
    meta: { requiresAuth: true }
  },
  {
    path: "/blog",
    name: "blog",
    component: Blog
  },
  {
    path: "/report/:id",
    name: "report",
    component: Report
  },
  {
    path: "/landing/:lang?",
    name: "landing",
    component: Landing
  },
  // otherwise redirect to home
  { path: "*", redirect: "/" }
];

const router = new VueRouter({
  mode: "history",
  // base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (token) {
      // Check if the token is expired
      try {
        const decoded = jwtDecode(token);
        const isExpired = Date.now() > decoded.exp * 1000;

        if (isExpired) {
          localStorage.removeItem("token");
          store.dispatch("authentication/logout");
          return next({ name: "login" });
        }
      } catch (error) {
        localStorage.removeItem("token");
        store.dispatch("authentication/logout");
        console.log({ error });
        return next({ name: "login" });
      }
      const user = store.state.user.all.items;
      if (!user.habeas_data || !user.is_active) {
        if (to.path !== "/edit-user") {
          next({ name: "edituser" });
        } else {
          next();
        }
        return;
      } else {
        next();
        return;
      }
    }
    if (token) {
      if (to.path !== "/login") {
        next({ name: "login" });
      } else {
        next();
      }
      store.dispatch("authentication/logout");
      return;
    }
    next("/landing/es");
  } else {
    next();
  }
});
export default router;
